// // material-ui
// import { styled } from '@mui/material/styles';
// import Drawer from '@mui/material/Drawer';

// // project imports
// import { DRAWER_WIDTH } from 'config';

// const openedMixin = (theme) => ({
//   width: DRAWER_WIDTH,
//   borderRight: '1px solid',
//   borderRightColor: theme.palette.divider,

//   transition: theme.transitions.create('width', {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.enteringScreen
//   }),

//   overflowX: 'hidden',
//   boxShadow: 'none',
//   ...theme.applyStyles('dark', { boxShadow: theme.customShadows.z1 })
// });

// const closedMixin = (theme) => ({
//   transition: theme.transitions.create('width', {
//     easing: theme.transitions.easing.sharp,
//     duration: theme.transitions.duration.leavingScreen
//   }),

//   overflowX: 'hidden',
//   width: theme.spacing(7.5),
//   borderRight: 'none',
//   boxShadow: theme.customShadows.z1
// });

// // ==============================|| DRAWER - MINI STYLED ||============================== //

// const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme }) => ({
//   width: DRAWER_WIDTH,
//   flexShrink: 0,
//   whiteSpace: 'nowrap',
//   boxSizing: 'border-box',
//   variants: [
//     {
//       props: ({ open }) => open,
//       style: { ...openedMixin(theme), '& .MuiDrawer-paper': openedMixin(theme) }
//     },
//     {
//       props: ({ open }) => !open,
//       style: { ...closedMixin(theme), '& .MuiDrawer-paper': closedMixin(theme) }
//     }
//   ]
// }));

// export default MiniDrawerStyled;




// material-ui
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

// project imports
import { DRAWER_WIDTH } from 'config';

const openedMixin = (theme) => ({
  width: DRAWER_WIDTH,
  borderRight: '1px solid',
  borderRightColor: theme.palette.divider,

  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),

  overflowX: 'hidden',
  boxShadow: 'none',
  ...theme.applyStyles('dark', { boxShadow: theme.customShadows.z1 })
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  
  overflowX: 'hidden',
  width: theme.spacing(7.5),
  borderRight: 'none',
  boxShadow: theme.customShadows.z1
});

const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: DRAWER_WIDTH,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    transition: 'width 0.2s ease',

    ...(open
      ? {
          ...openedMixin(theme),
          '& .MuiDrawer-paper': openedMixin(theme)
        }
      : {
          ...closedMixin(theme),
          '& .MuiDrawer-paper': closedMixin(theme)
        })
  })
);

export default MiniDrawerStyled;